import {
  j1 as LinkedHashMap,
  k9 as IllegalStateException,
  r6 as toString,
  y1 as asList,
  s9 as THROW_CCE,
  l1 as List,
  e6 as isInterface,
  h2 as emptyList,
  m6 as objectMeta,
  ga as VOID,
  o6 as setMetadataFor,
  h6 as get_js,
  d4 as toList,
  o9 as NotImplementedError,
  z9 as lazy,
  g6 as isObject,
  g9 as Enum,
  p5 as classMeta,
  a as getKClassFromExpression,
  z6 as KClass,
} from './kotlin-kotlin-stdlib.mjs';
import { b as get_exportableM } from './net.akehurst.kotlinx-kotlinx-collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class KotlinxReflect {
  constructor() {
    KotlinxReflect_instance = this;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.v4d_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    tmp_0.w4d_1 = tmp$ret$1;
    var tmp_1 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$2 = LinkedHashMap.n8();
    tmp_1.x4d_1 = tmp$ret$2;
    this.y4d_1 = get_exportableM(this.v4d_1);
  }
  z4d(qualifiedName, cls, enumValuesFunction) {
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.v4d_1;
    tmp0_set.m3(qualifiedName, cls);
    // Inline function 'kotlin.collections.set' call
    var tmp1_set = this.w4d_1;
    tmp1_set.m3(cls, qualifiedName);
    if (!(null == enumValuesFunction)) {
      // Inline function 'kotlin.collections.set' call
      var tmp2_set = this.x4d_1;
      tmp2_set.m3(qualifiedName, enumValuesFunction);
    }
  }
  a4e(qualifiedName) {
    var tmp0_elvis_lhs = this.y4d_1.get(qualifiedName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = 'Cannot find class ' + qualifiedName + ", is the class registered with KotlinxReflect and did you remember to call 'KotlinxReflectForModule.registerUsedClasses()'?";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  b4e(kclass) {
    var tmp0_elvis_lhs = this.w4d_1.u3(kclass);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = "Cannot get qualifiedName of '" + kclass + "' is it registered with KotlinxReflect and did you remember to call 'KotlinxReflectForModule.registerUsedClasses()'?";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  c4e(qualifiedName) {
    var tmp0_safe_receiver = this.x4d_1.u3(qualifiedName);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver();
    var tmp = tmp1_safe_receiver == null ? null : asList(tmp1_safe_receiver);
    var tmp2_elvis_lhs = (tmp == null ? true : isInterface(tmp, List)) ? tmp : THROW_CCE();
    return tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs;
  }
}
class ClassReflection {
  constructor(kclass) {
    this.d4e_1 = kclass;
    var tmp = this;
    tmp.e4e_1 = lazy(ClassReflection$allPropertyNames$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.f4e_1 = lazy(ClassReflection$allMemberFunctions$delegate$lambda);
  }
  wl() {
    return KotlinxReflect_getInstance().b4e(this.d4e_1);
  }
  g4e(constructorArgs) {
    var cls = get_js(this.d4e_1);
    var obj = new (Function.prototype.bind.apply(cls, [null].concat(constructorArgs)))();
    return isObject(obj) ? obj : THROW_CCE();
  }
  h4e() {
    var tmp = this.d4e_1;
    var n = tmp instanceof Enum;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_asDynamic = get_js(this.d4e_1);
    tmp$ret$0 = tmp0_asDynamic;
    var jsCls = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp1_asDynamic = Enum;
    tmp$ret$1 = tmp1_asDynamic;
    var ep = tmp$ret$1.prototype;
    var tp = Object.getPrototypeOf(jsCls.prototype);
    return ep == tp;
  }
  i4e() {
    var tmp;
    if (this.h4e()) {
      var tmp_0 = KotlinxReflect_getInstance().c4e(this.wl());
      tmp = isInterface(tmp_0, List) ? tmp_0 : THROW_CCE();
    } else {
      tmp = emptyList();
    }
    return tmp;
  }
  j4e(name) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_firstOrNull = this.i4e();
      var tmp0_iterator = tmp0_firstOrNull.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.kotlinx.reflect.ClassReflection.enumValueOf.<anonymous>' call
        tmp$ret$0 = element.ac_1 === name;
        if (tmp$ret$0) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp = tmp$ret$1;
    return (tmp == null ? true : tmp instanceof Enum) ? tmp : THROW_CCE();
  }
}
class ObjectReflection {
  constructor(self_0) {
    this.k4e_1 = self_0;
    var tmp = this;
    var tmp_0 = getKClassFromExpression(this.k4e_1);
    tmp.l4e_1 = isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
    var tmp_1 = this;
    tmp_1.m4e_1 = lazy(ObjectReflection$allPropertyNames$delegate$lambda(this));
  }
  n4e(propertyName) {
    var self_0 = this.k4e_1;
    return self_0[propertyName];
  }
  o4e(propertyName, value) {
    var self_0 = this.k4e_1;
    self_0[propertyName] = value;
  }
}
//endregion
var KotlinxReflect_instance;
function KotlinxReflect_getInstance() {
  if (KotlinxReflect_instance === VOID)
    new KotlinxReflect();
  return KotlinxReflect_instance;
}
function ClassReflection$allPropertyNames$delegate$lambda(this$0) {
  return function () {
    var cls = get_js(this$0.d4e_1);
    var js = function () {
      var p = [];
      var prt = cls.prototype; //Object.getPrototypeOf(cls);
      var nms = Object.getOwnPropertyNames(prt);
      for (var i = 0; i < nms.length; i++)
        if (p.indexOf(nms[i]) == -1)
          p.push(nms[i]);
      return p;
    }();
    return toList(js);
  };
}
function ClassReflection$allMemberFunctions$delegate$lambda() {
  throw NotImplementedError.eg();
}
function reflect(_this__u8e3s4) {
  return new ClassReflection(_this__u8e3s4);
}
function ObjectReflection$allPropertyNames$delegate$lambda(this$0) {
  return function () {
    var self_0 = this$0.k4e_1;
    var js = Object.getOwnPropertyNames(self_0);
    return toList(js);
  };
}
function reflect_0(_this__u8e3s4) {
  return new ObjectReflection(_this__u8e3s4);
}
//region block: post-declaration
setMetadataFor(KotlinxReflect, 'KotlinxReflect', objectMeta);
setMetadataFor(ClassReflection, 'ClassReflection', classMeta);
setMetadataFor(ObjectReflection, 'ObjectReflection', classMeta, VOID, VOID, VOID, VOID, [2]);
//endregion
//region block: exports
export {
  KotlinxReflect_getInstance as a,
  reflect as b,
  reflect_0 as c,
};
//endregion

//# sourceMappingURL=net.akehurst.kotlinx-kotlinx-reflect.mjs.map
